import { Checkbox } from '@cian/ui-kit/checkbox';
import * as React from 'react';

import { FDealType, FOfferType, isSuburban } from '../../../../../JsonQuery';
import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

export interface IDealTypeProps {
  dealType: FDealType;
  offerType: FOfferType;
  isDealRent: boolean | null;
  isByHomeowner: boolean | null;
  isFromOffrep: boolean | null;
  onIsByHomeownerChange(value: boolean | null): void;
  onIsFromOffrepChange(value: boolean | null): void;
  onIsDealRentChange(value: boolean | null): void;
}

export const DealType: React.FC<IDealTypeProps> = ({
  dealType,
  offerType,
  isDealRent,
  isByHomeowner,
  isFromOffrep,
  onIsByHomeownerChange,
  onIsFromOffrepChange,
  onIsDealRentChange,
}) => {
  const isByHomeownerAvailable = (offerType & (FOfferType.Residential & ~FOfferType.FlatNew)) !== 0;
  const isFromOffrepAvailable = (offerType & FOfferType.Commercial) !== 0;
  const isDealRentAvailable = dealType === FDealType.RentLongterm && (offerType & FOfferType.Flat) !== 0;
  const isSuburbanType = isSuburban(offerType);
  const label = isSuburbanType ? 'Продавец' : 'Тип сделки';

  return (
    <Filter id="advancedFilter_dealType" label={label}>
      <InlineFilterGroup>
        <InlineFilter>
          {isByHomeownerAvailable && (
            <Checkbox
              label="От собственника"
              checked={!!isByHomeowner}
              onChange={event => onIsByHomeownerChange(event.target.checked || null)}
            />
          )}
          {isFromOffrepAvailable && (
            <Checkbox
              label="От официального представителя"
              checked={!!isFromOffrep}
              onChange={event => onIsFromOffrepChange(event.target.checked || null)}
            />
          )}
        </InlineFilter>
        {isDealRentAvailable && (
          <InlineFilter>
            <Checkbox
              label="Сдай/Сними"
              checked={!!isDealRent}
              onChange={event => onIsDealRentChange(event.target.checked || null)}
            />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </Filter>
  );
};
